export default "__VITE_ASSET__0c06c27c__"